import script from "./UCMultiInputSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./UCMultiInputSelector.vue?vue&type=script&setup=true&lang=js"

import "./UCMultiInputSelector.vue?vue&type=style&index=0&id=41982065&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41982065"]])

export default __exports__